import { Box } from '@zoopla-eng/zds-components/box';
import { ToggleGroup } from '@zoopla-eng/zds-components/toggles';
import { getNewHomes } from '@zoopla/listing-search/filters/modal';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { getPathname } from './utils/get-pathname';

export const QuickFilters = () => {
    const { query, pathname, push } = useRouter();

    const [newHomes, setNewHomes] = useState(getNewHomes(query, pathname));

    return (
        <Box pb="$S500" bpM100={{ display: 'none' }}>
            <ToggleGroup
                label="Quick Filters"
                value={newHomes as string}
                items={[
                    {
                        id: 'new_homes_include',
                        value: 'include',
                        label: 'All listings'
                    },
                    {
                        id: 'new_homes_only',
                        value: 'only',
                        label: 'New homes only'
                    }
                ]}
                onValueChange={(newValue) => {
                    setNewHomes(newValue);
                    push({
                        pathname: getPathname(pathname, newValue),
                        query: query
                    });
                }}
            />
        </Box>
    );
};
